import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  filter() {
    const townshipId = this.element.querySelector("select").value
    const communitySelect = document.getElementById("community_id")
    if (!communitySelect) return

    const options = communitySelect.querySelectorAll("option[data-township-id]")
    options.forEach(option => {
      if (townshipId === "" || option.dataset.townshipId === townshipId) {
        option.hidden = false
        option.disabled = false
      } else {
        option.hidden = true
        option.disabled = true
        if (option.selected) {
          communitySelect.value = ""
        }
      }
    })
  }
}
